

export class DPTimeSheet {
    timesheet_id: number;
    user_id: number;
    project_id: number;
    task: string;
    hours: string;
    added_date: string;
    updated_date: string;
    notes: string;
    billable: number;

}


// WEBPACK FOOTER //
// ./src/app/portalv1/model/dp-timesheet.ts